"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useEloise = exports.ViewCol = exports.View = exports.UserDependentWidget = exports.ReportBug = exports.Other = exports.Map = exports.Login = exports.Logic = exports.Loading = exports.Life = exports.LargeTextInput = exports.Input = exports.Home = exports.Heading = exports.Header = exports.FlatList = exports.FileUpload = exports.FileTable = exports.EloiseWidget = exports.Eloise = exports.DropDown = exports.DateSelector = exports.DBTable = exports.DBList = exports.DBItem = exports.DBCards = exports.ConfirmationModal = exports.CollectionRender = exports.ChildrenModal = exports.Checkbox = exports.Canvas = exports.CalendarComponent = exports.Button = exports.AppIcon = void 0;
var App_1 = __importStar(require("./App"));
exports.Eloise = App_1.default;
Object.defineProperty(exports, "useEloise", { enumerable: true, get: function () { return App_1.useEloise; } });
var components_1 = require("./components");
Object.defineProperty(exports, "AppIcon", { enumerable: true, get: function () { return components_1.AppIcon; } });
Object.defineProperty(exports, "Button", { enumerable: true, get: function () { return components_1.Button; } });
Object.defineProperty(exports, "CalendarComponent", { enumerable: true, get: function () { return components_1.CalendarComponent; } });
Object.defineProperty(exports, "Canvas", { enumerable: true, get: function () { return components_1.Canvas; } });
Object.defineProperty(exports, "Checkbox", { enumerable: true, get: function () { return components_1.Checkbox; } });
Object.defineProperty(exports, "ChildrenModal", { enumerable: true, get: function () { return components_1.ChildrenModal; } });
Object.defineProperty(exports, "CollectionRender", { enumerable: true, get: function () { return components_1.CollectionRender; } });
Object.defineProperty(exports, "ConfirmationModal", { enumerable: true, get: function () { return components_1.ConfirmationModal; } });
Object.defineProperty(exports, "DBCards", { enumerable: true, get: function () { return components_1.DBCards; } });
Object.defineProperty(exports, "DBItem", { enumerable: true, get: function () { return components_1.DBItem; } });
Object.defineProperty(exports, "DBList", { enumerable: true, get: function () { return components_1.DBList; } });
Object.defineProperty(exports, "DBTable", { enumerable: true, get: function () { return components_1.DBTable; } });
Object.defineProperty(exports, "DateSelector", { enumerable: true, get: function () { return 
    //blocks
    components_1.DateSelector; } });
Object.defineProperty(exports, "DropDown", { enumerable: true, get: function () { return components_1.DropDown; } });
Object.defineProperty(exports, "EloiseWidget", { enumerable: true, get: function () { return components_1.EloiseWidget; } });
Object.defineProperty(exports, "FileTable", { enumerable: true, get: function () { return components_1.FileTable; } });
Object.defineProperty(exports, "FileUpload", { enumerable: true, get: function () { return components_1.FileUpload; } });
Object.defineProperty(exports, "FlatList", { enumerable: true, get: function () { return components_1.FlatList; } });
Object.defineProperty(exports, "Header", { enumerable: true, get: function () { return 
    // widgets
    components_1.Header; } });
Object.defineProperty(exports, "Heading", { enumerable: true, get: function () { return components_1.Heading; } });
Object.defineProperty(exports, "Home", { enumerable: true, get: function () { return 
    // pages
    components_1.Home; } });
Object.defineProperty(exports, "Input", { enumerable: true, get: function () { return components_1.Input; } });
Object.defineProperty(exports, "LargeTextInput", { enumerable: true, get: function () { return components_1.LargeTextInput; } });
Object.defineProperty(exports, "Life", { enumerable: true, get: function () { return components_1.Life; } });
Object.defineProperty(exports, "Loading", { enumerable: true, get: function () { return components_1.Loading; } });
Object.defineProperty(exports, "Login", { enumerable: true, get: function () { return components_1.Login; } });
Object.defineProperty(exports, "Map", { enumerable: true, get: function () { return components_1.Map; } });
Object.defineProperty(exports, "Other", { enumerable: true, get: function () { return 
    //todo Account
    components_1.Other; } });
Object.defineProperty(exports, "ReportBug", { enumerable: true, get: function () { return components_1.ReportBug; } });
Object.defineProperty(exports, "View", { enumerable: true, get: function () { return components_1.View; } });
Object.defineProperty(exports, "ViewCol", { enumerable: true, get: function () { return components_1.ViewCol; } });
var widgets_1 = require("./components/widgets");
Object.defineProperty(exports, "UserDependentWidget", { enumerable: true, get: function () { return widgets_1.UserDependentWidget; } });
var functions_1 = require("./functions");
Object.defineProperty(exports, "Logic", { enumerable: true, get: function () { return functions_1.Logic; } });
/**
 * An object representing the Eloise user.
 * @typedef {Object} EloiseUserObject
 * @property {function(): Promise<HistoryItem[]|boolean>} getHistory - Returns the history items for the current user or false if an error occurs.
 * @property {function(): Promise<BaseEloiseUser|boolean>} getUser - Returns the user data for the current user or false if an error occurs.
 */
/**
 * Represents a history item.
 * @typedef {Object} HistoryItem
 * @property {string} id - The ID of the history item.
 * @property {string} timestamp - The timestamp of the history item.
 * @property {string} action - The action associated with the history item.
 */
/**
 * Represents a base Eloise user.
 * @typedef {Object} BaseEloiseUser
 * @property {string} preName - The prename of the Eloise user.
 * @property {string} eduLevel - The educational level of the Eloise user.
 * @property {string} firstName - The first name of the Eloise user.
 * @property {string} lastName - The last name of the Eloise user.
 * @property {string} username - The username of the Eloise user.
 * @property {string} phoneNumber - The phone number of the Eloise user.
 * @property {string} country - The country of the Eloise user.
 * @property {string} email - The email of the Eloise user.
 * @property {string} perms - The permissions of the Eloise user.
 * @property {string} createdAt - The creation date of the Eloise user.
 * @property {number} curieUsage - The Curie usage of the Eloise user.
 * @property {number} davinciUsage - The Davinci usage of the Eloise user.
 * @property {string} userId - The user ID of the Eloise user.
 * @property {string} year - The year of the Eloise user.
 * @property {string} school - The school of the Eloise user.
 */
/**
 * An object representing the Eloise user.
 * @type {EloiseUserObject}
 */
